import React from "react";
import { Button, Dropdown, Icon } from "semantic-ui-react";
import "../../styles/ui.scss";

interface IBCButtonDropdown {
  options: any[];
  buttonClass?: string;
  buttonGroupClass?: string;
  buttonGroupText: string;
  handleOptionClick?: any;
  dropdownMenuClass?: string;
}

const BCButtonDropdown = ({ ...props }: IBCButtonDropdown) => {
  return (
    <Button.Group className={props.buttonGroupClass}>
      <Button className={props.buttonClass}>{props.buttonGroupText}</Button>
      <Dropdown
        className='button icon'
        trigger={<></>}
      >
        <Dropdown.Menu className={props.dropdownMenuClass ? props.dropdownMenuClass : "" }>
          {props.options && props.options.map((dropdownOption, i) => {
            return (
              <Dropdown.Item key={`dropdownOption-${i}`} onClick={() => props.handleOptionClick(i)}>
                {dropdownOption.icon && <Icon name={dropdownOption.icon} />}{dropdownOption.text}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </Button.Group>
  );
};

export default BCButtonDropdown;
